import { Text, View, StyleSheet } from '@react-pdf/renderer'
import moment from 'moment-timezone'

const styles = StyleSheet.create({
  footerCont: {
    flexDirection: 'row',
    flexWrap: 'wrap',
    margin: '0 30'
  },
  copy: {
    width: '50%',
    textAlign: 'left'
  },
  pageNmb: {
    width: '50%',
    textAlign: 'right'
  }
})

const Footer = ({ page, pages }) => {
  let now = moment().format('DD/MMM/YYYY')
  return (
  <View style={styles.footerCont}>
    <Text style={styles.copy}>Munogu &copy; {now}</Text>
    <Text styles={styles.pageNmb}>{`page: ${page}/${pages}`}</Text>
  </View>
  )
}

export default Footer
